import React from "react";

export default function SubtitlesPanel({ video }) {
return (
  <div
    className="
      p-4 flex flex-col gap-4
      text-gray-900 dark:text-gray-100
    "
  >
    {/* Title */}
    <h3 className="text-lg font-semibold">Subtitles</h3>

    {/* Description */}
    <div className="text-sm text-gray-600 dark:text-gray-400">
      Manage captions / import SRT
    </div>

    {/* Actions */}
    <div className="space-y-2 text-sm">
      <button
        className="
          w-full py-2 rounded-lg
          bg-gray-200 hover:bg-gray-300
          dark:bg-gray-700 dark:hover:bg-gray-600
          border border-gray-300 dark:border-gray-700
          transition-colors
        "
      >
        Import SRT
      </button>

      <button
        className="
          w-full py-2 rounded-lg
          bg-blue-600 hover:bg-blue-700
          text-white
          transition-colors
        "
      >
        Auto-generate
      </button>

      {/* Empty state */}
      <div className="mt-3 text-xs text-gray-500 dark:text-gray-400">
        No subtitles yet
      </div>
    </div>
  </div>
);

}